<template>
    <section id="section-doctor">
        <div class="section-head">
            <h2>Jadwal Dokter</h2>
        </div>
        <div class="section-body">
            <div class="section-body-inner">
                <div class="sbi-control">
                    <div class="sbi-control-part scp-left">
                        <div class="scp-button scp-button-left" @click="useDoctorStore().prevDoctor()">
                            <img src="../../assets/images/icons/arplay.png" alt="morula melinda hospital" />
                        </div>
                    </div>
                    <div class="sbi-control-part scp-right">
                        <div class="scp-button scp-button-right" @click="useDoctorStore().nextDoctor()">
                            <img src="../../assets/images/icons/arplay.png" alt="morula melinda hospital" />
                        </div>
                    </div>
                </div>
                <Transition name="fade-slide" mode="out-in">
                    <div class="sbi-content-wrapper" :key="doctor.id">
                        <div class="sbi-image">
                            <img :src="getImgUrl(doctor.image)" alt="morula melinda hospital" />
                        </div>
                        <div class="sbi-detail">
                            <div class="sbi-detail-name">
                                <h3>{{ doctor.name }}</h3>
                            </div>
                            <div class="sbi-detail-schedule">
                                <div class="sds-inner">
                                    <template v-for="sc in doctor.schedules" :key="sc">
                                        <div class="sds-row" v-if="sc.display">
                                            <div class="sds-row-param">
                                                <span>{{ sc.day }}</span>
                                            </div>
                                            <div class="sds-row-value">
                                                <span v-for="t in sc.time" :key="t" class="sds-time-slot">{{ t }}</span>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <div class="sds-legend">*By Appointment</div>
                            </div>
                        </div>
                    </div>
                </Transition>
            </div>
        </div>
    </section>
</template>

<script setup>
import { computed } from '@vue/reactivity';
import { useDoctorStore } from '@/stores/doctor';
const doctor = computed(() => useDoctorStore().doctor);
useDoctorStore().setDoctor(0);
function getImgUrl(image) {
    return require('../../assets/images/pictures/' + image);
}
</script>

<style scoped>
section {
    padding: 5rem 10% 2.5rem 10%;
    transition: 0.2s;
}

.section-head {
    text-align: center;
}

.section-head h2 {
    font-family: poppins;
    font-size: clamp(2rem, 5vw, 3.5rem);
    margin: 1rem 0 2.5rem 0;
    color: var(--primary);
    transition: 0.2s;
}

.section-body-inner {
    position: relative;
    width: 100%;
    min-height: 600px;
    height: auto;
    display: block;
    overflow: hidden;
    transition: 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.sbi-content-wrapper {
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
}

.sbi-control {
    position: absolute;
    top: 90%;
    left: 0;
    width: 40%;
    display: flex;
    transition: 0.3s;
    z-index: 10;
}

.sbi-control-part {
    display: flex;
}

.scp-left {
    width: 50%;
    justify-content: left;
}

.scp-right {
    width: 50%;
    justify-content: right;
}

.scp-button {
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--primary);
    border-radius: 50px;
    overflow: hidden;
    cursor: pointer;
    user-select: none;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.scp-button:hover {
    background: var(--primary-hover);
    transform: scale(1.1);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.scp-button:active {
    transform: scale(0.95);
}

.scp-button img {
    width: 50%;
}

.scp-button-left img {
    transform: rotate(180deg);
}

.sbi-image {
    width: 45%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    overflow: hidden;
    transition: 0.5s ease;
}

.sbi-image img {
    width: 100%;
    max-height: 600px;
    object-fit: contain;
}

.sbi-detail {
    width: 55%;
    transition: 0.3s;
    padding-left: 3rem;
}

.sbi-detail-name {
    padding: 1rem 0 1rem 2rem;
    border-left: 5px solid var(--primary-hover);
    font-family: poppins;
}

.sbi-detail-name h3 {
    margin: 0;
    color: var(--primary);
    font-size: clamp(1.4rem, 2.5vw, 2.2rem);
    line-height: 1.2;
    transition: 0.3s;
}

.sbi-detail-schedule {
    padding: 2.5rem 0 0 0;
}

.sds-inner {
    width: 100%;
    background: var(--smoke);
    padding: 2rem;
    border-radius: 30px;
    transition: 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.5);
}

.sds-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    font-size: clamp(1rem, 1.5vw, 1.3rem);
    font-family: poppins;
    font-weight: 500;
    color: var(--grey);
    border-bottom: 1px solid var(--softgrey);
    padding: 0.6rem 1rem;
    transition: 0.3s;
    border-radius: 8px;
}

.sds-row:hover {
    background: rgba(230, 135, 47, 0.08);
    transform: translateX(10px);
    color: var(--primary);
}

.sds-row-param {
    text-align: left;
}

.sds-row-value {
    text-align: right;
    display: flex;
    flex-direction: column;
}

.sds-time-slot {
    display: block;
}

.sds-legend {
    margin-top: 1rem;
    padding-left: 1rem;
    font-size: 0.9rem;
    font-style: italic;
    color: var(--primary);
    font-family: roboto;
    font-weight: 300;
}

/* Transition Classes */
.fade-slide-enter-active,
.fade-slide-leave-active {
    transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.fade-slide-enter-from {
    opacity: 0;
    transform: translateX(50px) scale(0.95);
}

.fade-slide-leave-to {
    opacity: 0;
    transform: translateX(-50px) scale(1.05);
}

@media only screen and (max-width: 1500px) {
    section {
        padding: 5rem 5% 2.5rem 5%;
    }
}

@media only screen and (max-width: 1200px) {
    .section-body-inner {
        min-height: auto;
    }

    .sbi-content-wrapper {
        flex-wrap: wrap;
        padding: 0 2rem;
    }

    .sbi-control {
        width: 100%;
        top: 180px;
    }

    .sbi-image {
        width: 100%;
        max-height: 400px;
    }

    .sbi-image img {
        height: 400px;
        width: auto;
    }

    .sbi-detail {
        width: 100%;
        padding-left: 0;
        margin-top: 2rem;
    }

    .sbi-detail-name {
        font-size: 1.5rem;
    }
}

@media only screen and (max-width: 750px) {
    section {
        padding: 5rem 2.5% 2.5rem 2.5%;
    }

    .section-head h2 {
        font-size: 2rem;
    }

    .sbi-detail-name h3 {
        font-size: 1.5rem;
    }

    .sds-inner {
        border-radius: 10px;
    }
}
</style>